import { Component, OnInit } from '@angular/core';
import { CommonDataService } from '../../services/common-data.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {

  title: string = "";
  ExceptionID: string = "";
  supportUrl: string = "";
  constructor(private commonDataService: CommonDataService) {
   }

  ngOnInit(): void {
    this.commonDataService.showLoader.next(false);
    this.title="An error occurred while processing your request!!";
    this.ExceptionID=history?.state?.errorId;
    this.supportUrl=history?.state?.url;
  }

}
